import { HASURA_DOCS_2_BASE_URL } from './constants';

export const PRO_DOCS = `https://docs.pro.hasura.io`;
export const EE_DOCS = `https://docs.ee.hasura.io`;
export const docs = {
  cloud: () => {
    return {
      root: () => HASURA_DOCS_2_BASE_URL + '/',
      postgresPermissions: () =>
        `${HASURA_DOCS_2_BASE_URL}/deployment/postgres-requirements/#postgres-permissions`,
      githubIntegration: () =>
        `${HASURA_DOCS_2_BASE_URL}/cloud-ci-cd/index/#hasura-cloud-github-integration`,
      dedicatedVPC: () =>
        `${HASURA_DOCS_2_BASE_URL}/hasura-cloud/dedicated-vpc/`,
      vpcPeering: () =>
        `${HASURA_DOCS_2_BASE_URL}/hasura-cloud/dedicated-vpc/#vpc-peering`,
      vpcPeeringAcceptRequest: () =>
        `https://hasura.io/docs/latest/hasura-cloud/dedicated-vpc/aws-network-peering/#step-2-accept-the-peering-request`,
      awsPeeringCustomerToHasura: () =>
        `https://hasura.io/docs/latest/hasura-cloud/dedicated-vpc/aws-network-peering/#customer-to-hasura`,
      multipleAdminSecrets: () =>
        `${HASURA_DOCS_2_BASE_URL}/authentication/multiple-admin-secrets/`,
      openTelemetry: () =>
        `${HASURA_DOCS_2_BASE_URL}/observability/opentelemetry/`,
      openTelemetryNew: () =>
        `${HASURA_DOCS_2_BASE_URL}/observability/opentelemetry/`,
    };
  },
  hasura: () => {
    return {
      root: () => HASURA_DOCS_2_BASE_URL + '/',
      jwtMode: () =>
        `${HASURA_DOCS_2_BASE_URL}/auth/authentication/jwt/#configure-hasura-jwt-mode`,
      serverEnvVars: (hash = 'command-flags') =>
        `${HASURA_DOCS_2_BASE_URL}/hasura-cli/config-reference/#${hash}`,
      configureCors: () =>
        `${HASURA_DOCS_2_BASE_URL}/deployment/graphql-engine-flags/config-examples/#configure-cors`,
      jwkUrl: () =>
        `${HASURA_DOCS_2_BASE_URL}/auth/authentication/jwt/#jwt-json-jwk_url`,
      jwtKey: () =>
        `${HASURA_DOCS_2_BASE_URL}/auth/authentication/jwt/#jwt-json-key`,
      jwtType: () =>
        `${HASURA_DOCS_2_BASE_URL}/auth/authentication/jwt/#jwt-json-type`,
      mySQL: () => `${HASURA_DOCS_2_BASE_URL}/databases/mysql/index/`,
      quickStartDocker: () =>
        `${HASURA_DOCS_2_BASE_URL}/getting-started/docker-simple/`,
    };
  },
  pro: () => {
    return {
      root: () => PRO_DOCS,
      getStarted: () =>
        `${PRO_DOCS}/getting-started/#step-1-setup-your-local-hasura-project`,
      addProject: () => `${PRO_DOCS}/getting-started/#step-2-create-a-project`,
      upgradePro: () =>
        `${PRO_DOCS}/getting-started/#step-3-run-hasura-with-pro-key`,
    };
  },
  ee: () => {
    return {
      root: () => EE_DOCS,
      addProject: () =>
        `${EE_DOCS}/graphql-installation/installation/#step-1-create-a-project-and-generate-the-pro-key`,
      upgradePro: () =>
        `${EE_DOCS}/graphql-installation/installation/#step-2-run-hasura-ee-data-plane-graphql-engine-with-the-pro-key`,
    };
  },
};

export const LEARN = `https://hasura.io/learn`;

export const HASURA_DATAHUB = `https://hasura.io/hub/`;

export const CHANGELOG = `https://hasura.io/changelog/cloud`;

export const CLOUD_TERMS_OF_SERVICE =
  'https://hasura.io/legal/hasura-cloud-terms-of-service';
export const HASURA_PRIVACY_POLICY =
  'https://hasura.io/legal/hasura-privacy-policy';

export const POSTGRES_CONNECTION_URI =
  'https://www.postgresql.org/docs/current/libpq-connect.html#id-1.7.3.8.3.6';

export const HEROKU_POSTGRES = `https://devcenter.heroku.com/articles/heroku-postgresql#provisioning-heroku-postgres`;

export const HASURA_GQL_ENGINE_GITHUB_DISCUSSIONS =
  'https://github.com/hasura/graphql-engine/discussions';

export const HASURA_ZENDESK_NEW_QUERY =
  'https://hasurahelp.zendesk.com/hc/en-us/requests/new';

export const GITHUB_INTEGRATION_STARTER_KIT = `https://github.com/hasura/github-integration-starter`;
